import { EmailsSortByDto, SortDirectionDto } from '@/api/generated';
import {
  EmailDialogsTranslation,
  emailDialogsTranslation,
} from '@/assets/locales/views/emails/dialogs/emailDialogs.translation.pl.ts';
import {
  NewEmailTranslation,
  newEmailTranslation,
} from '@/assets/locales/views/emails/newEmail/newEmail.translation.pl.ts';
import {
  threadEmailsTranslation,
  ThreadEmailsTranslation,
} from '@/assets/locales/views/emails/threadEmails/threadEmails.translation.pl.ts';
import {
  threadsListTranslation,
  ThreadsListTranslation,
} from '@/assets/locales/views/emails/threadsList/threadsList.translation.pl.ts';

export type EmailsViewTranslation = {
  dialogs: EmailDialogsTranslation;
  folders: {
    arrange: {
      alwaysVisible: string;
      button: string;
      cancel: string;
      hiddenByParent: string;
      intro: string;
      rules: {
        hiddenFolder: string;
        nothingDeleted: string;
        outlook: string;
        showAgain: string;
        subfolders: string;
      };
      save: string;
      title: string;
      visible: string;
    };
    filterFoldersPlaceholder: string;
    modals: {
      clean: {
        button: {
          clean: string;
        };
        content: string;
        title: string;
      };
    };
  };
  header: {
    sortBy: WithTitle & Record<EmailsSortByDto, string>;
    sortOrder: WithTitle & Record<SortDirectionDto, string>;
  };
  messages: { notYourEmail: string };
  newEmail: NewEmailTranslation;
  threadEmails: ThreadEmailsTranslation;
  threadsList: ThreadsListTranslation;
  toasts: {
    sendError: string;
    sendSuccess: string;
  };
};

type WithTitle = {
  title: string;
};

export const emailsViewTranslation: EmailsViewTranslation = {
  dialogs: emailDialogsTranslation,
  folders: {
    arrange: {
      alwaysVisible: 'Ten folder jest zawsze widoczny',
      button: 'Porządkuj foldery',
      cancel: 'Anuluj',
      hiddenByParent: 'Ukryty razem z folderem nadrzędnym',
      intro:
        'Przeciągnij folder za uchwyt, żeby zmienić kolejność. Przełącznikiem decydujesz, czy folder jest widoczny w aplikacji.',
      rules: {
        hiddenFolder:
          'Ukryty folder znika z listy, a aplikacja przestaje pobierać z niego pocztę i nie liczy go do nieprzeczytanych.',
        nothingDeleted:
          'Nic nie jest usuwane — wiadomości zostają w Outlooku, a maile przypięte do procesów nadal widać w procesie.',
        outlook: 'Kolejność i widoczność dotyczą tylko aplikacji — w Outlooku nic się nie zmienia.',
        showAgain:
          'Ponowne pokazanie folderu pobiera jego pocztę od nowa — może to potrwać kilka minut.',
        subfolders: 'Ukrycie folderu ukrywa też jego podfoldery.',
      },
      save: 'Zapisz',
      title: 'Porządkuj foldery',
      visible: 'Widoczny',
    },
    filterFoldersPlaceholder: 'Znajdź folder',
    modals: {
      clean: {
        button: {
          clean: 'Wyczyść',
        },
        content: 'Czy na pewno chcesz wyczyścić folder?',
        title: 'Potwierdź czyszczenie folderu',
      },
    },
  },
  header: {
    sortBy: {
      [EmailsSortByDto.Date]: 'Data',
      [EmailsSortByDto.From]: 'Od',
      [EmailsSortByDto.Subject]: 'Temat',
      [EmailsSortByDto.To]: 'Do',
      title: 'Sortuj po:',
    },
    sortOrder: {
      [SortDirectionDto.Asc]: 'Rosnąco',
      [SortDirectionDto.Desc]: 'Malejąco',
      title: 'Kierunek sortowania:',
    },
  },
  messages: {
    notYourEmail:
      'Email innego użytkownika. Jeżeli chcesz wziąć udział w konwersacji napisz nową wiadomość',
  },
  newEmail: newEmailTranslation,
  threadEmails: threadEmailsTranslation,
  threadsList: threadsListTranslation,
  toasts: {
    sendError: 'Wystąpił błąd podczas wysyłania emaila',
    sendSuccess: 'Email został wysłany',
  },
};
